/* eslint-disable import/prefer-default-export */
import * as React from "react"
import TopLayout from "./TopLayout"

export const wrapRootElement = (props) => {
    return <TopLayout {...props}>{props.element}</TopLayout>
}
